import { List } from "immutable"
import * as Moment from "moment"
import * as React from "react"
import { RichText } from "../../components/components"
import { Event } from "../../custom_api/api"
import { ActivityEditionN, ActivityEvent } from "../../custom_models/activity_edition"
import { moment } from "../../custom_utils/moment"
import { Block, Container } from "../components/library/container"
import { Block as BlockType, BlockRenderer } from "./block_renderer"
import { Book } from "./books_block"
import { trackActivitySubscribe } from "./library/tracking"

export interface ActivityEditionProps {
  readonly edition: ActivityEditionN
  readonly blocks: List<BlockType>
  readonly noticeTitle: string
  readonly noticeContents: string
}

export const maybeTimeSpan = (e: ActivityEvent | Event): JSX.Element => {
  if (e.start && e.end) return <span>{e.start} - {e.end}</span>
  if (e.start) return <span>{e.start}</span>
  if (e.end) return <span>{e.end}</span>
  return <></>
}

export class ActivityEdition extends React.Component<ActivityEditionProps> {
  constructor(props: ActivityEditionProps) {
    super(props)
  }

  render() {
    const { edition: e, blocks, noticeTitle, noticeContents } = this.props
    const retRichText = RichText(false, "view", () => e.signupText, () => null)


    return <>
      <Block>
        <section className="edition-detail">
          <div className="edition-detail__header">
            <h3 className="title--l">Over deze activiteit</h3>
          </div>

          <div className="edition edition--single">
            <div className="edition__column edition__column--first">
              {e.activityEvents.sort((a, b) => a.date < b.date ? -1 : 1).map((event, k) => {
                const date = moment(event.date).format("dddd D MMMM YYYY")
                return (
                  <div className="edition__event" key={`edition-event-${date}`}>
                    <span className="sr-text">Waar en wanneer: </span>
                    <time dateTime={moment(event.date).format('YYYY-MM-DD')}>
                      {date.charAt(0).toUpperCase() + date.slice(1)} {maybeTimeSpan(event)}
                      <svg className="edition__icon" width="15" height="17" aria-hidden="true"><use xlinkHref="#icon--calendar" /></svg>
                    </time>
                    <address>
                      {event.location}
                      <svg className="edition__icon" width="15" height="18" aria-hidden="true"><use xlinkHref="#icon--location" /></svg>
                    </address>
                    {e.cost && <div>
                      {e.cost}
                      <svg className="edition__icon" width="16" height="16" aria-hidden="true"><use xlinkHref="#icon--price" /></svg>
                    </div>}
                  </div>
                )
              })}

              {e.signupUrl &&
                <div className="edition__signup">
                  <a
                    href={e.signupUrl}
                    target="_blank"
                    className="link button"
                    onClick={() =>
                      e.activityEvents.map(event => (
                        trackActivitySubscribe(
                          Moment(event.date).format("DD/MM/YYYY"),
                          event.start,
                          event.end
                        )
                      ))
                    }
                  >
                    Meld je aan
                  </a>
                </div>
              }
            </div>

            <div className="edition__column edition__column--second">
              <div className="edition__info">
                {e.signupText &&
                  <Container>
                    <div className="rich__text">{<retRichText.type key={`rich-text-key-${e.id}`} {...retRichText.props} />}</div>
                  </Container>}

              </div>
            </div>
          </div>
        </section>
      </Block>
      <Block>
        {(noticeTitle || noticeContents) &&
          <>
            {noticeTitle && <h3>{noticeTitle}</h3>}
            {noticeContents && <div dangerouslySetInnerHTML={{ __html: noticeContents }} />}
          </>
        }

        {e.book && <Container>
          <aside className="edition__book">
            <Book
              title={e.book.title}
              author={e.book.author}
              imageUrl={`/api/v1/Book/${e.book.id}/ImageDownload`}
              imageAlt={`Boekentip ${e.book.title} - ${e.book.author}`}
              className="book--edition-list"
              url={e.book.url}
            />
          </aside>
        </Container>}

        {!blocks.isEmpty() && <hr className="pre-blocks-divider" />}

        <BlockRenderer blocks={blocks} />
      </Block>
    </>
  }
}
